// Function to get a GUID key from the route (request path)
export const getKeyFromRoute = (): string | null => {
    const path = window.location.pathname;
    // GUID regex: 8-4-4-4-12
    const guidRegex = /([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
    const match = path.match(guidRegex);
    return match ? match[1] : null;
};
//Function to get ilp key from a query string.
export const getIlpKeyFromQueryString = (): string | null => {
    const localQueryString = localStorage.getItem('querystring');
    const localParams = new URLSearchParams(localQueryString!);
    const ilpKey = localParams.get('key');
    return ilpKey;
};

export const getKeyFromQueryString = (): string | null => {
    const localQueryString = localStorage.getItem('querystring');
    const localParams = new URLSearchParams(localQueryString!);
    const key = localParams.get('key');
    return key;
};